import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { 
  FaEnvelope, 
  FaMapMarkerAlt, 
  FaClock,
  FaLinkedin,
  FaTwitter,
  FaGithub
} from 'react-icons/fa';

const Contact = () => {
  const contactInfo = [
    {
      icon: <FaEnvelope />,
      title: "Email",
      details: "nolan@stratis-ai.com",
      link: "mailto:nolan@stratis-ai.com"
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Office",
      details: "Lehi, UT",
      link: "#"
    },
    {
      icon: <FaClock />,
      title: "Business Hours",
      details: "Mon-Fri: 9AM-6PM MST",
      link: "#"
    }
  ];

  return (
    <>
      {/* Hero Section */}
      <section className="hero-section text-white" style={{ minHeight: '50vh' }}>
        <Container>
          <Row className="align-items-center min-vh-50">
            <Col lg={8} className="mx-auto text-center hero-content">
              <h1 className="display-4 fw-bold mb-4">Get in Touch</h1>
              <p className="lead mb-5 fs-5">
                Ready to transform your business with AI? Let's discuss your project 
                and how we can help you achieve your goals.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Contact Information */}
      <section className="section-padding">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <h2 className="fw-bold mb-5 text-center">Contact Information</h2>
              
              <Row>
                {contactInfo.map((info, index) => (
                  <Col md={4} key={index} className="mb-4">
                    <Card className="h-100 border-0 bg-light text-center">
                      <Card.Body className="p-4">
                        <div className="service-icon mx-auto mb-3" style={{ width: '60px', height: '60px' }}>
                          {info.icon}
                        </div>
                        <h5 className="fw-bold mb-2">{info.title}</h5>
                        <a 
                          href={info.link} 
                          className="text-decoration-none text-muted"
                          target={info.link.startsWith('http') ? '_blank' : '_self'}
                          rel={info.link.startsWith('http') ? 'noopener noreferrer' : ''}
                        >
                          {info.details}
                        </a>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>

              <div className="text-center mt-5">
                <Card className="border-0 bg-primary text-white">
                  <Card.Body className="p-5">
                    <h3 className="fw-bold mb-3">Schedule a Meeting</h3>
                    <p className="mb-4 fs-5">
                      Prefer to schedule a call? Book a time that works for you.
                    </p>
                    <Button 
                      variant="light" 
                      size="lg" 
                      className="px-5 py-3 fw-semibold"
                      href="https://calendly.com/nolan-crook"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Book a Consultation
                    </Button>
                  </Card.Body>
                </Card>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Social Media & Additional Info */}
      <section className="section-padding bg-light">
        <Container>
          <Row className="text-center">
            <Col lg={8} className="mx-auto">
              <h2 className="section-title">Connect With Us</h2>
              <p className="section-subtitle">
                Follow us on social media for the latest updates and insights
              </p>
              
              <div className="d-flex justify-content-center gap-4 mb-5">
                <a 
                  href="https://linkedin.com/company/stratis-ai" 
                  className="text-decoration-none"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="service-icon d-inline-flex">
                    <FaLinkedin />
                  </div>
                </a>
                <a 
                  href="https://twitter.com/stratis_ai" 
                  className="text-decoration-none"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="service-icon d-inline-flex">
                    <FaTwitter />
                  </div>
                </a>
                <a 
                  href="https://github.com/stratis-ai" 
                  className="text-decoration-none"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="service-icon d-inline-flex">
                    <FaGithub />
                  </div>
                </a>
              </div>

              <div className="row text-center">
                <Col md={4} className="mb-4">
                  <h5 className="fw-bold mb-3">Response Time</h5>
                  <p className="text-muted">We typically respond within 24 hours during business days</p>
                </Col>
                <Col md={4} className="mb-4">
                  <h5 className="fw-bold mb-3">Free Consultation</h5>
                  <p className="text-muted">Initial consultation is always free with no obligation</p>
                </Col>
                <Col md={4} className="mb-4">
                  <h5 className="fw-bold mb-3">NDA Available</h5>
                  <p className="text-muted">We're happy to sign NDAs to protect your confidential information</p>
                </Col>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Contact;